import React, {Component} from "react";
import Dropzone           from "react-dropzone";

import { MEMBER_TOKEN }   from "actions/const";

import { IS_VALID }       from "utils";

export default class MassUpload extends Component {
  render () {
    let {
      MemberToken,
      actions
    } = this.props;

    let {
      csvFile
    } = MemberToken;

    let displayText = IS_VALID(csvFile) ? csvFile.name || "No file name" : "Upload CSV File";

    return (
      <div>
        <Dropzone
          style={{
            margin: "auto",
            position: "relative",
            width: "200px",
            height: "200px",
            borderWidth: "2px",
            borderColor: "rgb(102, 102, 102)",
            borderStyle: "dashed",
            borderRadius: "5px"
          }}
          accept=".csv, text/csv"
          multiple={false}
          onDropAccepted={(files) => {
            actions.setValue(
              MEMBER_TOKEN,
              {
                csvFile: files[0]
              }
            );
          }}
          >
          {displayText}
        </Dropzone>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/Home/FormContainer/MassUpload.js